const handleCopyValue = (copyData, stateStatusAlert) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(copyData);
  } else {
    const el = document.createElement("textarea");
    el.style.position = "absolute";
    el.style.left = "-100vw";
    el.value = copyData;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }
  stateStatusAlert(true);
  setTimeout(() => {
    stateStatusAlert(false);
  }, 4000);
};

export default handleCopyValue;
